<template>
  <div :class="$style.window">
    <Header :class="$style.header"/>

    <div :class="$style.content"
         class="scroll py-4"
         v-chat-scroll="{always: true, smooth: true, scrollonremoved:true}">
      <transition-group name="fade-height" tag="div">
        <Message v-for="message in messages"
                 :key="message.id"
                 :type="message.type"
                 :owner="message.owner"
                 :message="message"/>

        <Message v-if="isSendingMessage"
                 :key="loadingMessage.id"
                 :type="loadingMessage.type"
                 :owner="loadingMessage.owner"
                 :message="loadingMessage"/>
      </transition-group>

      <transition name="fade-height">
        <QuickReplies v-if="isQuickRepliesOpen"/>
      </transition>
    </div>

    <SendMessage :class="$style.footer"/>
  </div>
</template>

<script>
  import Header from 'components/Header';
  import Message from 'components/Message';
  import SendMessage from 'components/SendMessage';
  import QuickReplies from 'components/QuickReplies';
  import {mapState, mapActions} from 'vuex';

  export default {
    name: 'Window',
    components: {SendMessage, Message, Header, QuickReplies},
    computed: {
      ...mapState({
        isSendingMessage: state => state.isSendingMessage,
        messages: state => state.messages,
        isQuickRepliesOpen: state => state.quickReplies.isOpen
      }),
      loadingMessage() {
        return {
          id: 'loading-typing',
          typing: {
            wait: 0,
            duration: 60000
          },
          owner: 'bot',
          type: 'empty'
        }
      }
    },
    mounted() {
      this.start();
    },
    methods: {
      ...mapActions(['start'])
    },
  };
</script>


<style lang="scss" module>
  $header-h: 88px;
  $footer-h: 52px;

  .window {
    position: relative;
    width: 100vw;
    height: 100vh;
  }

  .content,
  .header,
  .footer {
    position: absolute;
    left: 0;
    right: 0;
  }

  .content {
    width: 100%;
    top: $header-h;
    bottom: $footer-h;
  }

  .header {
    height: $header-h;
    top: 0;
  }

  .footer {
    height: $footer-h;
    bottom: 0;
  }
</style>
